import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px;
  color: #414141;

  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;
